export const EVENT_ADD = 'ADD_TO_CART';

export const EVENT_REMOVE = 'REMOVE_FROM_CART';

export const EVENT_REMOVE_ALL = 'REMOVE_ALL_FROM_CART';
